import { Injectable, inject } from '@angular/core';
import { CountryFeatureService } from '@security/user';
import type { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DefaultLayoutService {
  private readonly countryFeature = inject(CountryFeatureService);

  public expanded$: Subject<boolean> = new BehaviorSubject<boolean>(true);

  public constructor() {
    this.countryFeature.moreThanOneOption().then((result) => {
      this.expanded$.next(result);
    });
  }

  public setUserState(expanded: boolean) {
    this.expanded$.next(expanded);
  }
}
